import React from 'react'
import imageOne from '../../resource/gallery/inside-pages/png files-Recovered.png'
import imageThree from '../../resource/gallery/inside-pages/2.png'

const PhotoGallery = () => {
    const events = [
        "Monastery",
        "Meditation Program",
        "Pindapata",
        "Arama Pooja",
        "Kathina",
        "Garu Bhanda Pooja",
        "New Year Celebration",
        "Ordination",
        "Building Constructions",
        "Wesak",
      ];
  return (
    <div className="photoGallery-page inside-pages">
    <div className="right-box">
        <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
    </div>

    <h1 className='font-main  p-4 mt-4'>Photo Gallery</h1>


    <p className="mt-6 h4-bold p-4 text-center">Pooja, Ceremony, blessings priceless  
    </p>
    <p className="mt-5 h4-bold p-4 text-center">Photos bringing the memory timeless
    </p>
    <p className="mt-5 h4-bold p-4 text-center">More and more words within it endless</p>
    <p className="mt-5 h4-bold p-4 text-center">Joy brings faith courage and Happiness  </p>
 

    <div className="grid-container mt-6">
    <div className="grid">
        {events.map((event, index) => (
          <div key={index} className="card">
            <div className="image-container">
              <div className="image"></div>

            </div>
            <p className="title">{event}</p>
          </div>
        ))}
      </div>
    </div>

    <div className="bottom-box mt-5">
            <img src={imageThree} alt="bottom-image" width={600} />
        </div>
</div>
  )
}

export default PhotoGallery